import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Button,
  IconButton,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faXmark } from '@fortawesome/pro-regular-svg-icons';

/**
 * UnaddressedModal warns about remaining suggestions before applying actions.
 *
 * Props:
 * - open: bool
 * - title: string
 * - message: string
 * - actionLabel: string
 * - onAction: func
 * - onContinue: func
 * - onClose: func
 */
export const UnaddressedModal = ({
  open,
  title = 'issueTypeGoesHere',
  message = 'Not all suggestions have been addressed. Changes will not be made on unaddressed suggestions. Do you wish to proceed?',
  actionLabel = 'ActionGoesHere',
  onAction,
  onContinue,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 0 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Stack direction="row" spacing={1} alignItems="center">
            <FontAwesomeIcon icon={faCircleInfo} color="#c2411c" />
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {title}
            </Typography>
          </Stack>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Typography variant="body1" color="text.primary">
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'flex-start' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ width: '100%' }}>
          <Button
            variant="contained"
            className="myOdu__button primary"
            onClick={onAction}
            disabled={!onAction}
          >
            {actionLabel}
          </Button>
          <Button
            variant="outlined"
            className="myOdu__button secondary"
            onClick={onContinue}
            disabled={!onContinue}
          >
            Continue Editing
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default UnaddressedModal;
